import { HttpResult } from "widgets-for-react";
import { ActualityPageData, PageResult } from "../../sharepointPageApi/types/pageData";

export const allNewsBlockApi = async (page: number): Promise<HttpResult<PageResult<ActualityPageData>>> => {
    const res = await fetch(`/api/v1/pages/news?${new URLSearchParams({page: page.toString()}).toString()}`);

    if (!res.ok)
      return {
        kind: 'failed',
        status: res.status,
      }

    const data: PageResult<ActualityPageData> = await res.json();

    return {
      kind: 'result',
      status: 200,
      value: data,
    };
  }
